<!--  -->
<template>
  <div>
    <div class="headerBox">
      <div class="logoFlex">
        <div class="logoBox">
          <router-link to="/"
            ><img src="../../assets/web_logo.png" alt
          /></router-link>
        </div>
      </div>
      <div class="navBarBox">
        <div class="navTitle" @click="gotoDiv('header')">首页</div>
        <div class="navTitle" @click="gotoDiv('video')">教学视频</div>
        <div class="navTitle" @click="gotoDiv('plan')">定制计划</div>
        <!-- <div class="navTitle" @click="gotoDiv('community')">社区交流</div> -->
        <div class="navTitle" @click="gotoDiv('appBox')">下载APP</div>
        <div class="navTitle" @click="gotoDiv('college')">学院视频</div>
        <div class="navTitle" @click="gotoDiv('partner')">战略合作</div>
        <div class="navTitle" @click="gotoDiv('about')">关于我们</div>
        <div class="navTitle" @click="gotoDiv('contact')">联系我们</div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    gotoDiv(str) {
      if (str == "about") {
        this.$router.push("/webAboutUser");
        return false;
      }
      if (str == "contact") {
        this.$router.push("/webContact");
        return false;
      } else {
        this.$router
          .push({
            path: "/",
            query: {
              id: str,
            },
          })
          .catch((data) => {});
        this.$emit("gotoDiv", str);
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.headerBox {
  position: fixed;
  width: 100%;
  z-index: 4;
  background: #fff;
  border-bottom: 1px solid #fcfcfc;
  box-shadow: 3px 5px 7px #eaeaea;
  display: flex;
}
img {
  width: 100%;
  height: 100%;
}
.logoBox {
  width: 160px;
  // position: absolute;
  height: 60px;
  margin-top: 10px;
  cursor: pointer;
  background: #fff;
  border-radius: 0 0 10px 10px;
}
.logoFlex {
  width: 24%;
  display: flex;
  justify-content: flex-end;
}
.navBarBox {
  display: flex;
  height: 80px;
  line-height: 80px;
  margin-left: 26%;
  align-items: center;
}

.navTitle {
  // width: 10%;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  margin: 10px;
}
@media screen and (max-width: 1400px) and (min-width: 1160px) {
  .navBarBox {
    margin-left: 10%;
  }
  // .logoFlex{
  //   width: auto;
  // }
}
@media screen and (max-width: 1160px) and (min-width: 1000px) {
  .navBarBox {
    margin-left: 10%;
  }
  .logoFlex{
    width: auto;
    margin-left: 10%;
  }
}
@media screen and (max-width: 1000px) and (min-width: 700px) {
  .navBarBox {
    margin-left: 5%;
    
  }
  .logoFlex{
    width: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/web/common/header.vue